import { clone } from '@jack-henry/frontend-utils/functions';
import { IpRestrictionModelDto as BoIpRestrictionModelDto } from '@treasury/api/bo';
import { IpRestrictionModelDto as ConsumerIpRestrictionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { IpRestrictionAddress } from './ip-restriction-address.entity';

const nullBoCompanyUserIpRestrictions: BoIpRestrictionModelDto = {
    ipRestrictions: [],
    ipRestrictionsPending: [],
    userId: 0,
    restricted: false,
    restrictedPending: false,
};

export class CompanyUserIpRestrictions extends DomainEntity<
    BoIpRestrictionModelDto | ConsumerIpRestrictionModelDto
> {
    constructor(dto = clone(nullBoCompanyUserIpRestrictions)) {
        super(dto);
        if (this.dto.ipRestrictions) {
            this.restrictedIpAddresses = this.dto.ipRestrictions.map(
                ipRestrictionAddress => new IpRestrictionAddress(ipRestrictionAddress)
            );
        }
        if (this.dto.ipRestrictionsPending) {
            this.pendingRestrictedIpAddresses = this.dto.ipRestrictionsPending.map(
                ipRestrictionAddress => new IpRestrictionAddress(ipRestrictionAddress)
            );
        }
    }

    public restrictedIpAddresses: IpRestrictionAddress[] = [];

    public pendingRestrictedIpAddresses: IpRestrictionAddress[] = [];

    public createDefault(): this {
        return new CompanyUserIpRestrictions(clone(nullBoCompanyUserIpRestrictions)) as this;
    }

    public get restricted() {
        return this.dto.restricted ?? false;
    }

    public set restricted(value: boolean) {
        this.dto.restricted = value;
    }

    public get restrictedPending() {
        return this.dto.restrictedPending ?? false;
    }

    public set restrictedPending(value: boolean) {
        this.dto.restrictedPending = value;
    }
}
